import React, { useState } from 'react';
import './login.css'
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const Login = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();

      const { error } = await supabase.auth.signInWithPassword({
            email,
            password
        });

        if (error) {
            alert(error.message);
        } else {
            alert("Login successful!");
            navigate('/home');
        }
    };

    return (
    <>
    <section>
        <div className="containerr">

            <div className="login">

                <div className='logoo'></div>
                <div className='overlay'></div>

                <form className='logindiv' onSubmit={handleLogin}>

                    <div className='welcome'>
                        <h1 className='welcometxt'>Welcome Back</h1>
                        <p className='loginp'>
                            Sign in to continue your journey
                        </p>
                    </div>

                    <div className='inputsdiv'>

                        <div className='inputbox'>
                            <label>Email</label>
                            <input
                                type="email"
                                placeholder='Enter your email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className='inputbox'>
                            <label>Password</label>
                            <input
                                type="password"
                                placeholder='Enter your password'
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                    </div>

                    
                    <p className='helpp'>
                        Demo account:<br />
                        Gmail: janna@gmail.com<br />
                        Password: 123456<br />
                        Or create a new account below 
                    </p>

                    <button className='loginbt' type="submit">
                        LOGIN
                    </button>

                    <p className='bottomtxt'>
                        Don’t have an account?
                        <span onClick={() => navigate('/signup')}>
                            Sign Up
                        </span>
                    </p>

                </form>

            </div>

        </div>
    </section>
    </>
    );
}

export default Login;